import { useContext } from "react";
import ParamsContext from "../contexts/ParamsProvider";

const useGlobalParams = () => {
  return useContext(ParamsContext);
};

export default useGlobalParams;
